import Vue from 'vue';

const ENDPOINT_PREFIX = 'api/adbazaar/v4';
const ENDPOINTS = {
  CAMPAIGNS: `${ENDPOINT_PREFIX}/campaigns/`,
  CAMPAIGN: id => `${ENDPOINT_PREFIX}/campaigns/${id}/`,
  DAILY_STATS: `${ENDPOINT_PREFIX}/packages/daily-stats/`,
  OVERALL_STATS: `${ENDPOINT_PREFIX}/campaigns/overall-stats/`,
  CAMPAIGNS_DAILY_STATS: `${ENDPOINT_PREFIX}/campaigns/daily-stats/`,
  BIDS_STATS: `${ENDPOINT_PREFIX}/bids/overall-stats/`,
  CREATE_SMART_CAMPAIGN: `${ENDPOINT_PREFIX}/campaigns/basic/create/`,
  CREATE_DISCOVERY_CAMPAIGN: `${ENDPOINT_PREFIX}/campaigns/discovery/create/`,
  TRACKERS: `${ENDPOINT_PREFIX}/trackers/`,
};

// todo: refactor this
function getIdsParam(arr) {
  if (!arr?.length) return '';
  return `?campaign_ids=${arr}`;
}

export default {
  getCampaigns: ({ campaign_ids, ...params }) =>
    Vue.http.get(ENDPOINTS.CAMPAIGNS + getIdsParam(campaign_ids), { params }),
  getCampaignData: id => Vue.http.get(ENDPOINTS.CAMPAIGN(id)),
  updateCampaign: (id, payload) =>
    Vue.http.patch(ENDPOINTS.CAMPAIGN(id), payload),
  getPackageDailyStats: params =>
    Vue.http.get(ENDPOINTS.DAILY_STATS, { params }),
  exportPackageDailyStats: params =>
    Vue.http.get(ENDPOINTS.DAILY_STATS, { params, responseType: 'blob' }),
  getCampaignsDailyStats: ({ campaign_ids, ...params }) =>
    Vue.http.get(ENDPOINTS.CAMPAIGNS_DAILY_STATS + getIdsParam(campaign_ids), {
      params,
    }),
  exportCampaignsDailyStats: ({ campaign_ids, ...params }) =>
    Vue.http.get(ENDPOINTS.CAMPAIGNS_DAILY_STATS + getIdsParam(campaign_ids), {
      params,
      responseType: 'blob',
    }),
  getCampaignsOverallStats: ({ campaign_ids, ...params } = {}) =>
    Vue.http.get(ENDPOINTS.OVERALL_STATS + getIdsParam(campaign_ids), {
      params,
    }),
  getKeywordsStats: ({ campaign_ids, ...params }) =>
    Vue.http.get(ENDPOINTS.BIDS_STATS + getIdsParam(campaign_ids), { params }),
  exportKeywordsStats: ({ campaign_ids, ...params }) =>
    Vue.http.get(ENDPOINTS.BIDS_STATS + getIdsParam(campaign_ids), {
      params,
      responseType: 'blob',
    }),
};
